(function () {

  'use strict';



  var FAV_KEY = 'cw_favorites';



  function sanitizeFavoriteId(id) {
    var n = parseInt(String(id), 10);
    return Number.isFinite(n) && n > 0 ? String(n) : '';
  }

  function readFavorites() {
    try {
      var raw = localStorage.getItem(FAV_KEY);
      if (!raw) {
        return [];
      }
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) {
        return [];
      }
      var clean = [];
      var seen = {};
      for (var i = 0; i < parsed.length; i += 1) {
        var id = sanitizeFavoriteId(parsed[i]);
        if (!id || seen[id]) {
          continue;
        }
        seen[id] = true;
        clean.push(id);
      }
      if (clean.length !== parsed.length) {
        writeFavorites(clean);
      }
      return clean;
    } catch (err) {
      try {
        localStorage.removeItem(FAV_KEY);
      } catch (removeErr) {
        /* ignore */
      }
      return [];
    }
  }



  function writeFavorites(ids) {

    var clean = [];

    var seen = {};

    for (var i = 0; i < ids.length; i += 1) {
      var id = sanitizeFavoriteId(ids[i]);
      if (!id || seen[id]) {
        continue;
      }

      seen[id] = true;

      clean.push(id);

    }

    try {

      localStorage.setItem(FAV_KEY, JSON.stringify(clean));

    } catch (err) {

      /* ignore */

    }

    window.dispatchEvent(

      new CustomEvent('cw:favorites-changed', { detail: { ids: clean.slice() } })

    );

    return clean;

  }



  function toggleFavorite(productId) {

    var id = String(productId);

    if (!id) {

      return readFavorites();

    }

    var favs = readFavorites();

    var idx = favs.indexOf(id);

    if (idx >= 0) {

      favs.splice(idx, 1);

    } else {

      favs.push(id);

    }

    return writeFavorites(favs);

  }



  function isFavorite(productId) {

    return readFavorites().indexOf(String(productId)) >= 0;

  }



  function productIdFromWishButton(btn) {

    if (!btn) {

      return 0;

    }

    var article = btn.closest('[data-cw-product-id]');

    if (article) {

      var fromArticle = parseInt(String(article.getAttribute('data-cw-product-id') || ''), 10);

      if (fromArticle > 0) {

        return fromArticle;

      }

    }

    var direct = parseInt(String(btn.getAttribute('data-cw-product-id') || ''), 10);

    return direct > 0 ? direct : 0;

  }



  function syncWishButton(btn) {

    if (!btn) {

      return;

    }

    var productId = productIdFromWishButton(btn);

    if (!productId) {

      btn.hidden = true;

      return;

    }

    btn.hidden = false;

    var active = isFavorite(productId);

    btn.classList.toggle('is-active', active);

    btn.setAttribute('aria-pressed', active ? 'true' : 'false');

    btn.setAttribute(

      'aria-label',

      active ? 'Usuń z ulubionych' : 'Dodaj do ulubionych'

    );

  }



  function syncAllWishButtons(root) {

    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('[data-cw-wish]').forEach(syncWishButton);

  }



  document.addEventListener('click', function (e) {

    var btn = e.target.closest && e.target.closest('[data-cw-wish]');

    if (!btn) {

      return;

    }

    e.preventDefault();

    e.stopPropagation();

    var productId = productIdFromWishButton(btn);

    if (!productId) {

      return;

    }

    toggleFavorite(productId);

    syncWishButton(btn);

  });



  window.addEventListener('cw:favorites-changed', function () {

    syncAllWishButtons(document);

  });



  function bootWishButtons() {

    syncAllWishButtons(document);

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', bootWishButtons);

  } else {

    bootWishButtons();

  }



  window.CustomWearFavorites = {

    key: FAV_KEY,

    read: readFavorites,

    write: writeFavorites,

    toggle: toggleFavorite,

    isFavorite: isFavorite,

    syncWishButtons: syncAllWishButtons,

    count: function () {

      return readFavorites().length;

    }

  };

})();

